var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_524",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29236",
    "data-name": "Group 29236",
    transform: "translate(212 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -212, -10673)",
    filter: "url(#Ellipse_524)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_524-2",
    "data-name": "Ellipse 524",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50387",
    "data-name": "Path 50387",
    d: "M264.181,261.584l-2.944-2.071A5.13,5.13,0,0,0,259.266,257c-1.325-.765-2.4.047-2.4,1.813a5.744,5.744,0,0,0,2.4,4.583,1.509,1.509,0,0,0,1.627.091Zm0,0",
    transform: "translate(-431.306 -10889.092)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50388",
    "data-name": "Path 50388",
    d: "M34.348,13.066l-5.38-3.841-.6-1.316A12.932,12.932,0,0,0,23.105,2.1L21.329,1.1A7.017,7.017,0,0,0,15.757.455l-2.363.719L11.481.08a.592.592,0,0,0-.576-.009h0L.318,6.282A.6.6,0,0,0,0,6.812V8.455a3.3,3.3,0,0,0,1.652,2.86l22.6,13.053a4.955,4.955,0,0,0,5.019.02L35.086,21a1.944,1.944,0,0,0,.966-1.68V16.377a4.069,4.069,0,0,0-1.7-3.311Zm0,0",
    transform: "translate(-192.526 -10650.459)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50389",
    "data-name": "Path 50389",
    d: "M42.308,8.656A7.017,7.017,0,0,1,47.88,9.3l1.777.992a12.932,12.932,0,0,1,5.262,5.812l.6,1.317L66.1,11.214,65.5,9.9a12.933,12.933,0,0,0-5.262-5.812l-1.777-.992a7.017,7.017,0,0,0-5.573-.649l-2.363.719L39.945,9.374Zm0,0",
    transform: "translate(-229.659 -10652.449)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50390",
    "data-name": "Path 50390",
    d: "M24.452,123.769,21.508,121.7a5.128,5.128,0,0,0-1.972-2.516c-1.325-.765-2.4.047-2.4,1.813a5.744,5.744,0,0,0,2.4,4.583,1.509,1.509,0,0,0,1.627.091Zm0,0",
    transform: "translate(-208.458 -10760.98)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50391",
    "data-name": "Path 50391",
    d: "M5.1,6.29,7.017,7.385,17.6,1.174,15.686.08A.592.592,0,0,0,15.11.071h0L4.523,6.282A.6.6,0,0,1,5.1,6.29ZM38.919,18.131l.152-.7a2.353,2.353,0,0,1,1.154-1.557c0,.021,0,.042.007.062a4.068,4.068,0,0,0-1.679-2.872l-5.38-3.841L22.592,15.435l5.38,3.841a4.046,4.046,0,0,1,.68.614h0l1.505.845a1.7,1.7,0,0,0,1.685-.01.84.84,0,0,1,.841,0l.872.5Zm0,0",
    transform: "translate(-196.731 -10650.459)",
    fill: "#525e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50392",
    "data-name": "Path 50392",
    d: "M54.919,98.1a12.932,12.932,0,0,0-5.262-5.812L47.88,91.3a7.019,7.019,0,0,0-5.573-.649l-2.363.719a5,5,0,0,0,1.021,3.028l2.93,3.85,11.623,6.7V99.416Zm0,0",
    transform: "translate(-229.659 -10734.439)",
    fill: "#82a5b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50393",
    "data-name": "Path 50393",
    d: "M.9,88.264a.6.6,0,0,0-.9.522v1.642a3.3,3.3,0,0,0,1.652,2.86l5.112,2.947-2.93-3.85a5,5,0,0,1-1.021-3.028Zm22.769,14.661.566.326a5.028,5.028,0,0,0,.86.393l-.648-1.781a4.049,4.049,0,0,0-.68-.614l-5.379-3.841v5.529l5.283,3.046a1.138,1.138,0,0,1-.425-.746L23,103.371a.448.448,0,0,1,.668-.446Zm0,0",
    transform: "translate(-192.526 -10732.434)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50394",
    "data-name": "Path 50394",
    d: "M261.664,261.579c0,1.766-1.074,2.578-2.4,1.813a5.745,5.745,0,0,1-2.4-4.583c0-1.766,1.074-2.578,2.4-1.813A5.745,5.745,0,0,1,261.664,261.579Zm0,0",
    transform: "translate(-431.306 -10889.092)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50395",
    "data-name": "Path 50395",
    d: "M276.543,284.269c0,.868-.528,1.267-1.179.891a2.824,2.824,0,0,1-1.179-2.253c0-.868.528-1.268,1.179-.892A2.825,2.825,0,0,1,276.543,284.269Zm0,0",
    transform: "translate(-447.404 -10912.484)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50396",
    "data-name": "Path 50396",
    d: "M283.127,294.314c0,.471-.286.688-.639.484a1.532,1.532,0,0,1-.64-1.222c0-.471.286-.688.64-.484a1.532,1.532,0,0,1,.639,1.222Zm0,0",
    transform: "translate(-454.528 -10922.841)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50397",
    "data-name": "Path 50397",
    d: "M21.934,123.764c0,1.766-1.074,2.578-2.4,1.813a5.744,5.744,0,0,1-2.4-4.583c0-1.766,1.074-2.578,2.4-1.813A5.744,5.744,0,0,1,21.934,123.764Zm0,0",
    transform: "translate(-208.457 -10760.98)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50398",
    "data-name": "Path 50398",
    d: "M36.812,146.455c0,.868-.528,1.268-1.179.891a2.824,2.824,0,0,1-1.179-2.253c0-.868.528-1.267,1.179-.891a2.824,2.824,0,0,1,1.179,2.253Zm0,0",
    transform: "translate(-224.553 -10784.375)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50399",
    "data-name": "Path 50399",
    d: "M43.4,156.5c0,.471-.286.688-.64.484a1.532,1.532,0,0,1-.639-1.222c0-.471.286-.688.639-.484A1.532,1.532,0,0,1,43.4,156.5Zm0,0",
    transform: "translate(-231.678 -10794.729)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50400",
    "data-name": "Path 50400",
    d: "M349.493,284.523a5.032,5.032,0,0,0,2.514-.673l.087-.05-.872-.5a.84.84,0,0,0-.841,0,1.7,1.7,0,0,1-1.685.01l-1.505-.845.648,1.781A5.025,5.025,0,0,0,349.493,284.523Zm0,0",
    transform: "translate(-515.27 -10913.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50401",
    "data-name": "Path 50401",
    d: "M240.011,85.553,238.3,82.4a1.406,1.406,0,0,1,.533-1.887l7.369-4.254a1.283,1.283,0,0,1,1.753.469l1.839,3.182Zm0,0",
    transform: "translate(-413.889 -10721.184)",
    fill: "#304e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50402",
    "data-name": "Path 50402",
    d: "M156.6,120.744l6.188,3.2-.981-1.818a10.329,10.329,0,0,0-3.925-4.04l-.7-.4c-.191-.11-.387-.21-.584-.3Zm0,0",
    transform: "translate(-338.098 -10759.572)",
    fill: "#243b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50403",
    "data-name": "Path 50403",
    d: "M329.52,76.2a1.269,1.269,0,0,0-.539.164l-1.8,1.04,4.472,2.312-.981-1.818a10.349,10.349,0,0,0-1.151-1.7Zm0,0",
    transform: "translate(-496.668 -10721.292)",
    fill: "#59718b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50404",
    "data-name": "Path 50404",
    d: "M66.179,106.657a8.129,8.129,0,0,0-5.023-.054l-.871.273,5.894,3.047Zm0,0",
    transform: "translate(-248.566 -10749.21)",
    fill: "#243b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50405",
    "data-name": "Path 50405",
    d: "M493,227.708l1.338-.738v-1.016a4.074,4.074,0,0,0-.032-.5,2.354,2.354,0,0,0-1.155,1.557Zm0,0",
    transform: "translate(-650.812 -10860.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50406",
    "data-name": "Path 50406",
    d: "M99.631,135.07a1.023,1.023,0,0,1,.4.442,1.327,1.327,0,0,1,.138.594v.441a.506.506,0,0,1-.157.423.319.319,0,0,1-.381-.007l-.2-.114v1.144l-.344-.2v-3.037Zm.205.85a.48.48,0,0,0-.053-.222.366.366,0,0,0-.143-.155l-.207-.12v.972l.207.12a.117.117,0,0,0,.139,0,.184.184,0,0,0,.057-.153v-.444Zm1.113-.128a1.035,1.035,0,0,1,.386.437,1.3,1.3,0,0,1,.159.606v1.658a.5.5,0,0,1-.16.423.328.328,0,0,1-.385-.011,1.031,1.031,0,0,1-.385-.436,1.306,1.306,0,0,1-.158-.605v-1.658a.5.5,0,0,1,.16-.422A.326.326,0,0,1,100.949,135.792Zm.187.826a.468.468,0,0,0-.057-.219.374.374,0,0,0-.139-.157.12.12,0,0,0-.14,0,.177.177,0,0,0-.058.152v1.663a.465.465,0,0,0,.058.219.378.378,0,0,0,.14.157.118.118,0,0,0,.139,0,.18.18,0,0,0,.057-.152Zm1.6,3.281-.936-.541v-3.037l.344.2V139.1l.592.342Zm.58.335-.344-.2V137l.344.2Zm.849.529a1.035,1.035,0,0,1-.386-.435,1.294,1.294,0,0,1-.159-.6v-1.658a.5.5,0,0,1,.16-.423.328.328,0,0,1,.385.01,1.03,1.03,0,0,1,.385.436,1.3,1.3,0,0,1,.158.605v.347l-.356-.205v-.357a.475.475,0,0,0-.058-.22.376.376,0,0,0-.14-.158.117.117,0,0,0-.139,0,.184.184,0,0,0-.057.154v1.663a.47.47,0,0,0,.057.219.374.374,0,0,0,.139.156.12.12,0,0,0,.14,0,.177.177,0,0,0,.058-.152v-.419l.356.206v.424a.492.492,0,0,1-.16.421A.328.328,0,0,1,104.163,140.763Zm.825.438v-3.039l.978.565v.46l-.634-.366v.829l.464.268v.461l-.464-.268v.829l.635.366v.461Zm6.119-1.79,9.338,5.244,6.533-3.719-6.229-7.186Zm0,0",
    transform: "translate(-284.638 -10774.791)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50407",
    "data-name": "Path 50407",
    d: "M226.621,38.727l-2.178-1.258L218.324,41v.7l2.161,1.247,6.136-3.543Zm0,0",
    transform: "translate(-395.477 -10685.289)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50408",
    "data-name": "Path 50408",
    d: "M218.324,87.637v.7l2.161,1.247v-.683Zm0,0",
    transform: "translate(-395.477 -10731.925)",
    fill: "#525e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50409",
    "data-name": "Path 50409",
    d: "M249.008,58.875l6.136-3.543v.682l-6.136,3.543Zm0,0",
    transform: "translate(-424.001 -10701.895)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50410",
    "data-name": "Path 50410",
    d: "M236.75,23.79l-.109-.063a.47.47,0,0,0-.472-.042l0-.006-2.606,1.5-2.321,1.34a.628.628,0,0,0-.274.6v.831l1.572.907,4.945-2.846v-.831A1.752,1.752,0,0,0,236.75,23.79Zm0,0",
    transform: "translate(-407.228 -10672.434)",
    fill: "#243b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50411",
    "data-name": "Path 50411",
    d: "M271.01,23.79l-.109-.063a.47.47,0,0,0-.472-.042l0-.006-2.606,1.5a.765.765,0,0,1,.549,0l.109.063a1.752,1.752,0,0,1,.732,1.4v.831l2.533-1.457v-.831A1.752,1.752,0,0,0,271.01,23.79Zm0,0",
    transform: "translate(-441.488 -10672.434)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50412",
    "data-name": "Path 50412",
    d: "M237.841,44.488l-.109-.063a.441.441,0,0,0-.542.009l-.006-.01-2.321,1.34a.477.477,0,0,1,.457.049l.109.063a1.752,1.752,0,0,1,.731,1.4v.831l2.412-1.389v-.831A1.751,1.751,0,0,0,237.841,44.488Zm0,0",
    transform: "translate(-410.852 -10691.674)",
    fill: "#304e75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolice);
export default __webpack_public_path__ + "static/media/police.5605bd405c3d2a1e60987e5f606fc421.svg";
export { ForwardRef as ReactComponent };